import * as Yup from "yup";

export const schema = Yup.object().shape({
  waiting_list_external_url: Yup.string()
    .nullable()
    .url("Debe ser una URL válida")
    .test(
      "is-https",
      "La URL debe comenzar con https://",
      (value) => !value || value.startsWith("https://")
    ),
    waiting_list_cta_text: Yup.string()
    .required("Este campo es obligatorio")
    .max(25, "No puede tener más de 25 caracteres"),
});

interface FormValues {
  waiting_list_external_url: string | null;
  waiting_list_cta_text: string | null;
}

export const initialValues: FormValues = {
  waiting_list_external_url: "",
  waiting_list_cta_text: "Reservar mi lugar",
};